import Icon from '@components/ui/icon/icon';
export default Icon;
